export const SET_USER_VALUE = "SET_USER_VALUE";
export const SET_VIDEO_VALUE = "SET_VIDEO_VALUE";
export const FETCH_VIDEOS = "FETCH_VIDEOS";
export const FETCH_WEEKLY_VIDEOS = "FETCH_WEEKLY_VIDEOS";
export const FETCH_AMA_VIDEOS = "FETCH_AMA_VIDEOS";
export const ASYNC_ACTION_START = "ASYNC_ACTION_START";
export const ASYNC_ACTION_FINISH = "ASYNC_ACTION_FINISH";
export const ASYNC_ACTION_ERROR = "ASYNC_ACTION_ERROR";
